var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "#777"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "link_svg__a",
    width: "111.4%",
    height: "107.4%",
    x: "-5.7%",
    y: "-3.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    filter: "url(#link_svg__a)",
    transform: "translate(-650 -864.062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M666.573 865.49c-1.938-1.939-5.048-1.874-6.938.015l-2.248 2.248c1.32-.424 2.345-.13 3.241.245l.652-.652c.928-.928 2.475-.879 3.387.033.928.928.994 2.492.066 3.42l-3.03 3.028a2.488 2.488 0 01-1.172.652c-1.173.163-2.296-.424-2.72-1.45l-1.986 1.922c1.367 2.068 4.201 2.769 6.449 1.498.374-.196.732-.488 1.058-.814l3.224-3.224c1.889-1.89 1.955-4.984.017-6.922zm-10.717 4.055c-.39.196-.749.488-1.058.814l-3.354 3.338c-1.89 1.889-1.955 4.983-.017 6.921 1.938 1.938 5.048 1.873 6.937-.016l2.248-2.248c-1.319.424-2.344.13-3.24-.244l-.652.651c-.928.928-2.475.88-3.387-.033-.928-.928-.994-2.491-.066-3.42l3.143-3.143a2.495 2.495 0 011.173-.652c1.173-.163 2.296.424 2.72 1.45l2.003-1.922c-1.384-2.066-4.218-2.767-6.45-1.496z"
  }))));
}
export default SvgLink;